(function () {
  function initCategoryStrip(root) {
    if (!root || root.dataset.categoryStripReady === 'true') return;

    var track = root.querySelector('[data-category-strip-track]');
    var nextBtn = root.querySelector('[data-category-strip-next]');
    if (!track || !nextBtn) return;

    root.dataset.categoryStripReady = 'true';

    function scrollAmount() {
      var item = track.querySelector('.category-strip__item');
      if (!item) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 20;
      return (item.getBoundingClientRect().width + gap) * 3;
    }

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      var canScroll = maxScroll > 0;
      nextBtn.hidden = !canScroll;
      if (!canScroll) return;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateNav).observe(track);
    }

    updateNav();
  }

  function initAll() {
    document.querySelectorAll('[data-category-strip]').forEach(initCategoryStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-category-strip]');
    if (root) {
      root.dataset.categoryStripReady = 'false';
      initCategoryStrip(root);
    }
  });
})();
